'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var Component = require('./Component.js');
require('react');
require('classnames');
require('react-transition-group');
require('react-popper');
require('@alfalab/core-components-portal/dist/cssm');
require('./index.module.css');



exports.Popover = Component.Popover;
